<template>
	<div class="useri">
		<div class="useri_left">
			<div class="useril_sp1"><span>常见问题</span></div>

			<div class="useril_a2_mar">
				<a :class="'useril_a2' + (selectIndex == 0 ? ' useril_a2_select' : '')" @click="select(0)">商品退换</a>
			</div>
			<div class="useril_sp1"><span>商城信息</span></div>
			<div class="useril_a2_mar">
				<a :class="'useril_a2' + (selectIndex == 1 ? ' useril_a2_select' : '')" @click="select(1)">联系我们</a>
			</div>

			<div class="useril_sp1"><span>配送方式</span></div>
			<div class="useril_a2_mar">
				<a :class="'useril_a2' + (selectIndex == 2 ? ' useril_a2_select' : '')" @click="select(2)">货到付款</a>
				<a :class="'useril_a2' + (selectIndex == 3 ? ' useril_a2_select' : '')" @click="select(3)">上门自取</a>
				<a :class="'useril_a2' + (selectIndex == 4 ? ' useril_a2_select' : '')" @click="select(4)">第三方配送</a>
				<a :class="'useril_a2' + (selectIndex == 5 ? ' useril_a2_select' : '')" @click="select(5)">何时发货</a>
			</div>
		</div>
		<div class="useri_right">
			<div class="useri_right_pad" v-if="selectIndex == 0">
				<div class="useri_right_pad_title">商品退换</div>
				<span class="useri_right_pad_text">一、 退换货总则<br />
					1. 海外商品一律不接受任何无理由的退换货申请。<br />
					2. 商品签收后不予退换货，但有质量问题除外。<br />
					3. 用户签收商品之日（以邮政EMS快递单上用户签收时间为准）起7日内，如商品本身存在质量问题，您可以联系客服进行退货、换货<br />
					4. 用户签收商品之日（以邮政EMS快递单上用户签收时间为准）起第8日至第15日内，如商品本身存在质量问题，您可以联系客服进行换货<br />
					5. 因商品质量问题引起的退换货，运费由商家承担，但用户需将商品寄回至商家的退换货地址。<br />
					二、 退换货办理必须同时满足以下条件<br />
					1. 商品及商品本身的外包装完整且没有损坏，保持商品出售时的原质原样；<br />
					2. 注明退货原因，如果商品存在质量问题，请用户务必提供有效证明；<br />
					3. 如果成套商品中有部分商品存在质量问题，在办理换货时，必须提供成套商品。<br />
					4. 商品的包装完整，包括包裹填充物及外包装箱或外包装袋，商品附件、说明书、保修单、吊牌、标签等齐全，请勿将胶带、快递单等直接粘在商品自带的包装盒上，务必保持商品及包装原质原样。<br />
					三、 以下情况不予办理退换货<br />
					1. 非通过商城购买的商品；<br />
					2. 商城特殊说明中明确不可以退货的情形；<br />
					3. 商品描述中明确说明不可以退换的商品；<br />
					4. 个性化定制的商品；<br />
					5. 组合套装中部分商品单独退换；<br />
					6. 已使用过的商品，但商品本身存在质量问题除外；<br />
					7. 因非正常使用及保管导致出现质量问题的商品；<br />
					8. 商品的外包装不完整或破损（完整的包装包括：包裹填充物及外包装箱或外包装袋，商品附件、说明书、保修单、吊牌、标签等齐全保持商品出售时的原质原样）。<br />
					9. 未经服务中心确认同意退换货的商品。<br />
					10. 未能将退换商品寄回指定的退换货服务中心的，不予办理退换货。 换货<br />
				</span>
			</div>

			<div class="useri_right_pad" v-if="selectIndex == 1">
				<div class="useri_right_pad_title">联系我们</div>
				<span class="useri_right_pad_text">
					如有疑问请咨询平台客服<br />
					客服热线：400-838-2226 <br />
					我们将持续为您服务！<br />
				</span>
			</div>

			<div class="useri_right_pad" v-if="selectIndex == 2">
				<div class="useri_right_pad_title">货到付款</div>
				<span class="useri_right_pad_text">
					本商城在全国大部分城市中开通了货到付款服务。查看您是否享受该服务 <br />
					您可选择现金、POS机刷卡、支票的方式支付货款：<br />
					POS机刷卡：目前仅支持带有银联标识的银行卡，信用卡POS机刷卡消费赠送积分以各银行为准，具体信息请致电发卡行确认。若您下单时在订单中填写POS机刷卡，支付时也可换成现金支付。<br />
					支票支付：需要您将支票内容填写完整且需要款到账后方可送货，目前仅北京、上海两地客户可使用此服务，其余区域暂不支持支票支付。支票支付详情查询请点击此处<br />
					其中，本商城快递配送时可支持现金、POS机刷卡、支票支付（仅限北京、上海两个地区）。（具体支付方式您可与为您送货时的配送员联系咨询）<br />
					本商城自营商品配送费：运费信息详情见：配送费收取标准查询<br />
					第三方卖家商品配送费：以卖家在商品信息页公示的运费信息为准。<br />
				</span>
			</div>

			<div class="useri_right_pad" v-if="selectIndex == 3">
				<div class="useri_right_pad_title">上门自取</div>
				<span class="useri_right_pad_text">
					下单时，配送方式选择“上门自提”（请选择离您最近的自提点或自提柜），自提订单提交成功后，订单到达指定自提点或自提柜，系统会向收货人手机发送自提码，然后到自提点或自提柜通过自提码提货即可。
				</span>
			</div>

			<div class="useri_right_pad" v-if="selectIndex == 4">
				<div class="useri_right_pad_title">第三方配送</div>
				<span class="useri_right_pad_text">
					什么是第三方配送？<br />
					为了保证全国各地的客户都能在鲸买购物，对于鲸买自营配送无法送达的订单会委托专业的第三方快递公司进行配送。<br />
					服务说明：<br />
					1.鲸买委托第三方快递公司为客户提供送货上门服务，客户无须向快递公司支付额外的费用。<br />
					2.客户可以在鲸买网站“我的订单”查询货物配送信息，也可以登录第三方快递网站查询快递信息。<br />
					3.目前在山东、河北、河南、广东、黑龙江、吉林、四川、重庆、云南等省份的部分城市支持第三方货到付款业务，具体情况以提交订单时所显示为准；在广州、成都、武汉支持POS机刷卡业务；暂时不支持支票业务。<br />
					4.第三方快递支持客户打开运输包装验货，商品包装完好，客户可以先签收，如果发现商品有质量问题可以致电鲸买客服进行售后处理。<br />
					注意事项：<br />
					1.请在提交订单时准确选择地址信息，否则有可能导致货到付款订单无法送达和配送超时。<br />
					2.签收时请注意检查外包装是否完好，发票和配件是否齐全，签收后如果发现异常可以致电鲸买客服。<br />
				</span>
			</div>

			<div class="useri_right_pad" v-if="selectIndex == 5">
				<div class="useri_right_pad_title">何时发货</div>
				<span class="useri_right_pad_text">
					自营商品：现货订单，付款后鲸买网自营发货时间大部分预计在24小时内（具体以订单跟踪信息实际发货时间为准），商品从库房出库，安排第三方快递公司配送。<br />
					第三方商家销售的商品：现货订单，第三方商家的发货时间预计在24小时内。<br />
					详细进度您可以进入“我的订单”，通过追踪功能实时查看订单进度。温馨提示：若遇大型活动或是预售商品等，第三方商家销售的商品订单发货量大，发货时间一般以商品详情页面为准，预售商品一般情况商家会在商品页面说明发货时间，给您带来不便，请您谅解，谢谢。<br />
				</span>
			</div>

		</div>
	</div>
</template>


<script>
import { mapState } from 'vuex';
	export default {

		data() {
			return {
				// selectIndex: 0
			}
		},
		computed: {
			...mapState(['selectIndex']),
		},
		watch: {
			
		},
		created: function() {
			if(typeof(this.$route.query.index) != "undefined"){
				this.$store.commit('updateSelectIndex', this.$route.query.index);
			}
			console.log(this.selectIndex,'index');
		},
		mounted: function() {
			this.$store.commit('updateSelectIndex', this.$route.query.index);
		},
		methods: {
			select(index) {
				this.$store.commit('updateSelectIndex', index);
			}
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped >
    .useri_right_pad_title{
	width: 100%;
	text-align: center;
	color: #333333;
	font-size: 18px;
	font-weight: 600;
	margin-bottom: 20px;
}

.useri_right_pad_text{
	font-size: 14px;
	color: #333333;
}
</style>
<style lang="scss" scoped src="./mobile.scss" ></style>